import React, { createContext, useContext, ReactNode } from 'react';
import { CreateInvoiceFormData } from './schema';

interface CreateInvoiceContextType {
  formData: CreateInvoiceFormData | null;
  isPreviewOpen: boolean;
  setIsPreviewOpen: (open: boolean) => void;
}

const CreateInvoiceContext = createContext<CreateInvoiceContextType | null>(null);

export const useCreateInvoiceContext = () => {
  const context = useContext(CreateInvoiceContext);
  if (!context) {
    throw new Error('useCreateInvoiceContext must be used within a CreateInvoiceProvider');
  }
  return context;
};

interface CreateInvoiceProviderProps {
  children: ReactNode;
  formData: CreateInvoiceFormData | null;
  isPreviewOpen: boolean;
  setIsPreviewOpen: (open: boolean) => void;
}

export const CreateInvoiceProvider: React.FC<CreateInvoiceProviderProps> = ({
  children,
  formData,
  isPreviewOpen,
  setIsPreviewOpen,
}) => {
  return (
    <CreateInvoiceContext.Provider
      value={{
        formData,
        isPreviewOpen,
        setIsPreviewOpen,
      }}
    >
      {children}
    </CreateInvoiceContext.Provider>
  );
};